module.exports = __webpack_public_path__ + "./fonts/FontAwesome5_Solid.ttf";